import {Intro} from "../../components/compound/Intro/Intro";
import Services from "../../components/atomic/services";
import LearnMore from "../../components/atomic/learn-more";
import Support from "../../components/atomic/support";
import Application from "../../components/atomic/application";
import { useEffect } from "react";

export default function Home(){
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = '   پارسیان بیت'
    }, [])

    return (
        <>
            <Intro />
            <Services />
            <LearnMore />
            <Support />
            <Application />
        </>
    );
}
